(function () {
  const SAMPLE_HEADERS = ["SKU", "QTY required"];
  const SAMPLE_ROWS = [
    SAMPLE_HEADERS,
    ["BULK-001", "12"],
    ["BULK-002", "24"]
  ];
  let productIndexPromise = null;

  function normaliseHeader(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function parseCsv(text) {
    const rows = [];
    let currentValue = "";
    let currentRow = [];
    let insideQuotes = false;

    for (let index = 0; index < text.length; index += 1) {
      const character = text[index];
      const nextCharacter = text[index + 1];

      if (character === '"') {
        if (insideQuotes && nextCharacter === '"') {
          currentValue += '"';
          index += 1;
        } else {
          insideQuotes = !insideQuotes;
        }
        continue;
      }

      if (character === "," && !insideQuotes) {
        currentRow.push(currentValue);
        currentValue = "";
        continue;
      }

      if ((character === "\n" || character === "\r") && !insideQuotes) {
        if (character === "\r" && nextCharacter === "\n") {
          index += 1;
        }

        currentRow.push(currentValue);
        rows.push(currentRow);
        currentRow = [];
        currentValue = "";
        continue;
      }

      currentValue += character;
    }

    if (currentValue.length || currentRow.length) {
      currentRow.push(currentValue);
      rows.push(currentRow);
    }

    return rows.filter(function (row) {
      return row.some(function (cell) {
        return cell && cell.toString().trim() !== "";
      });
    });
  }

  function csvEscape(value) {
    const stringValue = String(value);
    if (/[",\n]/.test(stringValue)) {
      return '"' + stringValue.replace(/"/g, '""') + '"';
    }
    return stringValue;
  }

  function downloadSampleCsv() {
    const csvContent = SAMPLE_ROWS.map(function (row) {
      return row.map(csvEscape).join(",");
    }).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "bulk-order-sample.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function formatPreOrderDate(value) {
    const rawValue = String(value || "").trim();
    if (!rawValue) {
      return "";
    }

    const parsedDate = new Date(rawValue);
    if (Number.isNaN(parsedDate.getTime())) {
      return rawValue;
    }

    return new Intl.DateTimeFormat(navigator.language || "en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric"
    }).format(parsedDate);
  }

  function getPreOrderMessage(result) {
    const formattedDate = formatPreOrderDate(result.preOrderDate);
    if (formattedDate) {
      return "Pre-order item. Expected from " + formattedDate + ".";
    }

    return "Pre-order item. Date to be confirmed.";
  }

  function getRowMessage(result) {
    if (result.removed) {
      return "Removed from checkout.";
    }

    if (result.message) {
      return result.message;
    }

    if (result.isPreOrder) {
      return getPreOrderMessage(result);
    }

    return result.ok ? "Ready for checkout." : "Needs review.";
  }

  function getRowTone(result) {
    if (result.removed) {
      return "is-warning";
    }

    if (!result.ok) {
      return "is-error";
    }

    if (result.isPreOrder) {
      return "is-warning";
    }

    return "is-success";
  }

  function buildActionCell(result) {
    if ((result.ok && !result.isPreOrder) || result.reviewLocked) {
      return "";
    }

    return [
      '<button type="button" class="bulk-order-upload__row-action" data-bulk-order-toggle-row="',
      escapeHtml(String(result.rowNumber)),
      '">',
      escapeHtml(result.removed ? "Add back" : "Remove"),
      "</button>"
    ].join("");
  }

  function buildTableRow(result) {
    return [
      "<tr>",
      "<td>" + result.rowNumber + "</td>",
      "<td>" + escapeHtml(result.sku) + "</td>",
      "<td>" + escapeHtml(result.productTitle) + "</td>",
      "<td>" + escapeHtml(String(result.quantity)) + "</td>",
      '<td class="bulk-order-upload__cell-status ' + getRowTone(result) + '">',
      escapeHtml(getRowMessage(result)),
      "</td>",
      "<td>",
      buildActionCell(result),
      "</td>",
      "</tr>"
    ].join("");
  }

  function parseCartAddErrorMessage(payload, fallbackMessage) {
    if (!payload || typeof payload !== "object") {
      return fallbackMessage;
    }

    if (typeof payload.description === "string" && payload.description.trim()) {
      return payload.description.trim();
    }

    if (typeof payload.message === "string" && payload.message.trim()) {
      return payload.message.trim();
    }

    return fallbackMessage;
  }

  function mapCartAddFailure(message) {
    const normalisedMessage = String(message || "").toLowerCase();

    if (
      normalisedMessage.includes("sold out") ||
      normalisedMessage.includes("out of stock") ||
      normalisedMessage.includes("not enough") ||
      normalisedMessage.includes("available quantity") ||
      normalisedMessage.includes("available stock") ||
      normalisedMessage.includes("can't add")
    ) {
      return "Out of stock. This item was not added to cart.";
    }

    return "Shopify could not add this item to cart.";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function setStatus(element, message, tone) {
    element.textContent = message;
    element.classList.remove("is-success", "is-error", "is-warning");
    if (tone) {
      element.classList.add(tone);
    }
  }

  function validateProductIndex(payload) {
    if (!payload || typeof payload !== "object") {
      throw new Error("The bulk order SKU index is unavailable. Regenerate bulk-order-product-index.json from Shopify Admin and upload it to the theme.");
    }

    const itemsBySku = payload.itemsBySku && typeof payload.itemsBySku === "object" ? payload.itemsBySku : {};
    const duplicateSkus = Array.isArray(payload.duplicateSkus) ? payload.duplicateSkus : [];
    const generatedAt = typeof payload.generatedAt === "string" ? payload.generatedAt : "";
    const shop = typeof payload.shop === "string" ? payload.shop : "";
    const variantCount = typeof payload.variantCount === "number" ? payload.variantCount : Object.keys(itemsBySku).length;
    const generatedAtMs = generatedAt ? Date.parse(generatedAt) : NaN;
    const hasSkuEntries = Object.keys(itemsBySku).length > 0 && variantCount > 0;

    if (!generatedAt || Number.isNaN(generatedAtMs) || !shop || !hasSkuEntries) {
      throw new Error("The bulk order SKU index is empty or still using placeholder data. Regenerate bulk-order-product-index.json from Shopify Admin and upload the refreshed file to the live theme.");
    }

    return {
      itemsBySku: itemsBySku,
      duplicateSkus: duplicateSkus,
      variantCount: variantCount,
      generatedAt: generatedAt,
      shop: shop
    };
  }

  async function loadProductIndex(root) {
    if (productIndexPromise) {
      return productIndexPromise;
    }

    const productIndexUrl = root.getAttribute("data-product-index-url");
    if (!productIndexUrl) {
      throw new Error("The bulk order page is missing its SKU index asset. Add bulk-order-product-index.json to the theme assets.");
    }

    productIndexPromise = fetch(productIndexUrl, {
      headers: {
        Accept: "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("The bulk order SKU index could not be loaded from the theme. Upload a fresh bulk-order-product-index.json asset and try again.");
        }

        const contentType = response.headers.get("content-type") || "";
        if (!contentType.includes("application/json")) {
          throw new Error("The bulk order SKU index asset did not return JSON. Re-upload bulk-order-product-index.json to the theme assets.");
        }

        return response.json();
      })
      .then(function (payload) {
        return validateProductIndex(payload);
      })
      .catch(function (error) {
        productIndexPromise = null;
        throw error;
      });

    return productIndexPromise;
  }

  function normaliseText(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function parseRows(rows) {
    if (!rows.length) {
      throw new Error("The CSV file is empty.");
    }

    const headerRow = rows[0].map(normaliseHeader);
    const skuIndex = headerRow.indexOf("sku");
    const quantityIndex = headerRow.indexOf("qty required");

    if (skuIndex === -1 || quantityIndex === -1) {
      throw new Error("The CSV headers must include: SKU and QTY required. Product title is optional.");
    }

    const titleIndex = headerRow.indexOf("product title");

    return rows.slice(1).map(function (row, offset) {
      return {
        rowNumber: offset + 2,
        sku: (row[skuIndex] || "").trim(),
        productTitle: titleIndex === -1 ? "" : (row[titleIndex] || "").trim(),
        quantity: Number.parseInt((row[quantityIndex] || "").trim(), 10)
      };
    }).filter(function (row) {
      return row.sku || row.productTitle || row.quantity;
    });
  }

  function getIndexedMatch(index, row) {
    const itemsBySku = index && index.itemsBySku ? index.itemsBySku : {};
    const skuKey = String(row.sku || "").trim().toUpperCase();
    const matches = Array.isArray(itemsBySku[skuKey]) ? itemsBySku[skuKey] : [];

    if (!matches.length) {
      return null;
    }

    if (!row.productTitle) {
      return matches.length === 1 ? matches[0] : null;
    }

    const targetTitle = normaliseText(row.productTitle);
    const exactTitleMatch = matches.find(function (match) {
      return normaliseText(match.productTitle) === targetTitle;
    });

    if (exactTitleMatch) {
      return exactTitleMatch;
    }

    return matches.length === 1 ? matches[0] : null;
  }

  function getSelectedRows(rows) {
    return rows.filter(function (row) {
      return row.ok && !row.removed;
    });
  }

  function renderReviewState(root) {
    const state = root._bulkOrderState;
    if (!state) {
      return;
    }

    const summary = root.querySelector("[data-bulk-order-summary]");
    const tableBody = root.querySelector("[data-bulk-order-table-body]");
    const warning = root.querySelector("[data-bulk-order-preorder-warning]");
    const warningTitle = root.querySelector("[data-bulk-order-preorder-warning-title]");
    const warningBody = root.querySelector("[data-bulk-order-preorder-warning-body]");
    const checkoutButton = root.querySelector("[data-bulk-order-checkout]");
    const checkoutUrl = root.getAttribute("data-checkout-url");
    const selectedRows = getSelectedRows(state.rows);
    const activeInvalidRows = state.rows.filter(function (row) {
      return !row.ok && !row.removed;
    });
    const activePreOrderRows = selectedRows.filter(function (row) {
      return row.isPreOrder;
    });
    const removedPreOrderCount = state.rows.filter(function (row) {
      return row.isPreOrder && row.removed;
    }).length;
    const removedInvalidCount = state.rows.filter(function (row) {
      return !row.ok && row.removed;
    }).length;

    tableBody.innerHTML = state.rows.map(buildTableRow).join("");

    if (warning) {
      warning.hidden = activePreOrderRows.length === 0;
    }

    if (warningTitle) {
      warningTitle.textContent = activePreOrderRows.length
        ? "Some selected items are pre-order products."
        : "";
    }

    if (warningBody) {
      warningBody.textContent = activePreOrderRows.length
        ? "Orders containing these items may be held until all products are available. Remove them below if you want in-stock items to ship sooner."
        : "";
    }

    if (summary) {
      if (!selectedRows.length) {
        setStatus(summary, "No items are selected for checkout. Add back any rows you still want to order.", "is-error");
      } else if (activeInvalidRows.length) {
        setStatus(
          summary,
          selectedRows.length + " row(s) are ready. Remove " + activeInvalidRows.length + " invalid row(s) before continuing to checkout.",
          "is-error"
        );
      } else if (activePreOrderRows.length) {
        setStatus(
          summary,
          selectedRows.length + " row(s) are selected for checkout. " + activePreOrderRows.length + " pre-order row(s) still need review.",
          "is-warning"
        );
      } else if (removedPreOrderCount || removedInvalidCount) {
        setStatus(
          summary,
          selectedRows.length + " row(s) are ready for checkout." + (
            removedPreOrderCount ? " " + removedPreOrderCount + " pre-order row(s) were removed." : ""
          ) + (
            removedInvalidCount ? " " + removedInvalidCount + " invalid row(s) were removed." : ""
          ),
          "is-success"
        );
      } else {
        setStatus(summary, selectedRows.length + " row(s) are ready for checkout.", "is-success");
      }
    }

    if (checkoutButton) {
      checkoutButton.hidden = selectedRows.length === 0 || activeInvalidRows.length > 0;
      checkoutButton.textContent = activePreOrderRows.length
        ? "Continue with selected items"
        : "Add selected items and continue to checkout";
      if (checkoutUrl) {
        checkoutButton.href = checkoutUrl;
      }
    }
  }

  async function resolveVariant(root, row) {
    if (!row.sku) {
      return {
        ok: false,
        message: "Missing SKU.",
        rowNumber: row.rowNumber,
        sku: row.sku,
        productTitle: row.productTitle,
        quantity: row.quantity
      };
    }

    if (!Number.isInteger(row.quantity) || row.quantity <= 0) {
      return {
        ok: false,
        message: "Quantity must be a whole number above 0.",
        rowNumber: row.rowNumber,
        sku: row.sku,
        productTitle: row.productTitle,
        quantity: row.quantity
      };
    }

    const productIndex = await loadProductIndex(root);
    const indexedItem = getIndexedMatch(productIndex, row);

    if (indexedItem && indexedItem.variantId) {
      return {
        ok: true,
        message: indexedItem.isPreOrder ? getPreOrderMessage(indexedItem) : "Ready for checkout.",
        rowNumber: row.rowNumber,
        sku: row.sku,
        productTitle: indexedItem.productTitle || row.productTitle,
        quantity: row.quantity,
        variantId: indexedItem.variantId,
        isPreOrder: Boolean(indexedItem.isPreOrder),
        preOrderDate: indexedItem.preOrderDate || "",
        removed: false,
        reviewLocked: false
      };
    }

    const duplicateSkus = Array.isArray(productIndex.duplicateSkus) ? productIndex.duplicateSkus : [];
    if (duplicateSkus.indexOf(String(row.sku || "").trim().toUpperCase()) !== -1) {
      return {
        ok: false,
        message: "SKU matched multiple variants in the product index.",
        rowNumber: row.rowNumber,
        sku: row.sku,
        productTitle: row.productTitle,
        quantity: row.quantity
      };
    }

    return {
      ok: false,
      message: "SKU was not found in the current bulk order index. Refresh bulk-order-product-index.json from Shopify Admin and try again.",
      rowNumber: row.rowNumber,
      sku: row.sku,
      productTitle: row.productTitle,
      quantity: row.quantity
    };
  }

  async function addItemsToCart(items) {
    const results = [];

    for (const item of items) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: item.variantId,
              quantity: item.quantity
            }
          ]
        })
      });

      if (response.ok) {
        results.push({
          ok: true,
          variantId: item.variantId
        });
        continue;
      }

      let payload = null;

      try {
        payload = await response.json();
      } catch (error) {
        payload = null;
      }

      const failureMessage = parseCartAddErrorMessage(
        payload,
        "Shopify could not add this item to cart."
      );

      results.push({
        ok: false,
        variantId: item.variantId,
        message: mapCartAddFailure(failureMessage)
      });
    }

    return results;
  }

  function toggleReviewRow(root, rowNumber) {
    const state = root._bulkOrderState;
    if (!state || state.stage !== "review") {
      return;
    }

    state.rows = state.rows.map(function (row) {
      if (String(row.rowNumber) !== String(rowNumber) || (row.ok && !row.isPreOrder)) {
        return row;
      }

      return Object.assign({}, row, {
        removed: !row.removed
      });
    });

    renderReviewState(root);
  }

  async function addSelectedItemsToCart(root) {
    const status = root.querySelector("[data-bulk-order-status]");
    const summary = root.querySelector("[data-bulk-order-summary]");
    const tableBody = root.querySelector("[data-bulk-order-table-body]");
    const warning = root.querySelector("[data-bulk-order-preorder-warning]");
    const checkoutButton = root.querySelector("[data-bulk-order-checkout]");
    const checkoutUrl = root.getAttribute("data-checkout-url");
    const state = root._bulkOrderState;

    if (!state) {
      return;
    }

    const selectedRows = getSelectedRows(state.rows);

    if (!selectedRows.length) {
      setStatus(status, "No items are selected for checkout.", "is-error");
      renderReviewState(root);
      return;
    }

    if (checkoutButton) {
      checkoutButton.hidden = true;
    }

    setStatus(status, "Adding items to cart...", null);

    const cartAddResults = await addItemsToCart(selectedRows);
    const updatedRows = state.rows.map(function (row) {
      if (!row.ok || row.removed) {
        return Object.assign({}, row, {
          reviewLocked: true
        });
      }

      const cartAddResult = cartAddResults.find(function (result) {
        return result.variantId === row.variantId;
      });

      if (!cartAddResult || cartAddResult.ok) {
        return Object.assign({}, row, {
          reviewLocked: true
        });
      }

      return Object.assign({}, row, {
        ok: false,
        message: cartAddResult.message,
        reviewLocked: true
      });
    });

    root._bulkOrderState = {
      rows: updatedRows,
      stage: "post-add"
    };

    tableBody.innerHTML = updatedRows.map(buildTableRow).join("");

    if (warning) {
      warning.hidden = true;
    }

    const cartFailures = updatedRows.filter(function (row) {
      return !row.ok && !row.removed;
    });
    const cartSuccesses = updatedRows.filter(function (row) {
      return row.ok && !row.removed;
    });
    const removedPreOrderCount = updatedRows.filter(function (row) {
      return row.isPreOrder && row.removed;
    }).length;

    if (!cartSuccesses.length) {
      setStatus(status, "No items could be added to cart.", "is-error");
      setStatus(
        summary,
        cartFailures.length + " row(s) could not be added. Review the table and try again.",
        "is-error"
      );
      return;
    }

    if (cartFailures.length) {
      setStatus(status, "Available items were added to cart. Some rows could not be added.", "is-error");
      setStatus(
        summary,
        cartSuccesses.length + " row(s) were added. " + cartFailures.length + " row(s) could not be added." + (
          removedPreOrderCount ? " " + removedPreOrderCount + " pre-order row(s) were removed from checkout." : ""
        ),
        "is-error"
      );
      if (checkoutButton && checkoutUrl) {
        checkoutButton.href = checkoutUrl;
        checkoutButton.textContent = "Review added items and continue to checkout";
        checkoutButton.hidden = false;
      }
      return;
    }

    setStatus(status, "Everything is in the cart. Redirecting to checkout...", "is-success");
    setStatus(
      summary,
      cartSuccesses.length + " row(s) were added successfully. Sending the customer to checkout now.",
      "is-success"
    );

    window.location.href = checkoutUrl;
  }

  async function handleProcess(root) {
    const fileInput = root.querySelector("[data-bulk-order-file]");
    const status = root.querySelector("[data-bulk-order-status]");
    const results = root.querySelector("[data-bulk-order-results]");
    const summary = root.querySelector("[data-bulk-order-summary]");
    const tableBody = root.querySelector("[data-bulk-order-table-body]");
    const warning = root.querySelector("[data-bulk-order-preorder-warning]");
    const checkoutUrl = root.getAttribute("data-checkout-url");
    const processButton = root.querySelector("[data-process-bulk-order]");
    const sampleButton = root.querySelector("[data-download-sample-csv]");
    const checkoutButton = root.querySelector("[data-bulk-order-checkout]");

    root._bulkOrderState = null;

    if (checkoutButton) {
      checkoutButton.hidden = true;
      checkoutButton.textContent = "Review added items and continue to checkout";
    }

    if (warning) {
      warning.hidden = true;
    }

    if (!fileInput.files || !fileInput.files[0]) {
      setStatus(status, "Choose a CSV file before continuing.", "is-error");
      return;
    }

    if (processButton) {
      processButton.disabled = true;
      processButton.textContent = "Processing...";
    }

    if (sampleButton) {
      sampleButton.disabled = true;
    }

    setStatus(status, "Reading file and validating rows...", null);
    results.hidden = true;
    summary.textContent = "";
    tableBody.innerHTML = "";

    try {
      const fileText = await fileInput.files[0].text();
      const rows = parseRows(parseCsv(fileText));

      if (!rows.length) {
        throw new Error("The CSV only contains headers. Add at least one product row.");
      }

      setStatus(status, "Matching SKUs to products...", null);

      const resolvedRows = [];
      for (const row of rows) {
        resolvedRows.push(await resolveVariant(root, row));
      }

      tableBody.innerHTML = resolvedRows.map(buildTableRow).join("");
      results.hidden = false;

      const invalidRows = resolvedRows.filter(function (row) {
        return !row.ok;
      });

      root._bulkOrderState = {
        rows: resolvedRows,
        stage: "review"
      };

      const preOrderRows = resolvedRows.filter(function (row) {
        return row.isPreOrder;
      });

      if (invalidRows.length) {
        setStatus(status, "Remove invalid rows before continuing to checkout.", "is-error");
        renderReviewState(root);
        return;
      }

      if (preOrderRows.length) {
        setStatus(status, "Review pre-order items before continuing to checkout.", "is-warning");
        renderReviewState(root);
        return;
      }

      await addSelectedItemsToCart(root);
    } catch (error) {
      setStatus(status, error.message || "Something went wrong while processing the CSV.", "is-error");
    } finally {
      if (processButton) {
        processButton.disabled = false;
        processButton.textContent = "Upload New";
      }

      if (sampleButton) {
        sampleButton.disabled = false;
      }
    }
  }

  function initialiseBulkOrder(root) {
    if (!root || root.hasAttribute("data-bulk-order-initialised")) {
      return;
    }

    root.setAttribute("data-bulk-order-initialised", "true");

    const sampleButton = root.querySelector("[data-download-sample-csv]");
    const processButton = root.querySelector("[data-process-bulk-order]");
    const checkoutButton = root.querySelector("[data-bulk-order-checkout]");
    const tableBody = root.querySelector("[data-bulk-order-table-body]");

    if (sampleButton) {
      sampleButton.addEventListener("click", downloadSampleCsv);
    }

    if (processButton) {
      processButton.addEventListener("click", function () {
        handleProcess(root);
      });
    }

    if (checkoutButton) {
      checkoutButton.addEventListener("click", function (event) {
        if (!root._bulkOrderState || root._bulkOrderState.stage !== "review") {
          return;
        }

        event.preventDefault();
        addSelectedItemsToCart(root).catch(function (error) {
          const status = root.querySelector("[data-bulk-order-status]");
          setStatus(status, error.message || "Something went wrong while adding items to cart.", "is-error");
        });
      });
    }

    if (tableBody) {
      tableBody.addEventListener("click", function (event) {
        const toggleButton = event.target.closest("[data-bulk-order-toggle-row]");
        if (!toggleButton) {
          return;
        }

        toggleReviewRow(root, toggleButton.getAttribute("data-bulk-order-toggle-row"));
      });
    }
  }

  function initialiseAllBulkOrders(container) {
    const scope = container || document;
    scope.querySelectorAll("[data-bulk-order-root]").forEach(initialiseBulkOrder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialiseAllBulkOrders(document);
    });
  } else {
    initialiseAllBulkOrders(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialiseAllBulkOrders(event.target);
  });
})();